import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import {
  BoxContainer,
  CardBox,
  PageContent,
  ScrollContent
} from '@nile/banyan/src/Utils/style';
import {
  AccessControl,
  CascadeCard,
  NoDataCard,
  getLokaliseKeyByProduct,
  getTranslatedText
} from '@nile/components';
import { DeleteModal } from '@nile/components/src';
import {
  Avatar,
  Button,
  ButtonGroup,
  DisplayText,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { Component } from 'react';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { sortBy } from 'lodash';

class TechGroupCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      currentProduct: props.currentProduct,
      value: [],
      selectedTechGroup:
        props.techGroups.length > 0 ? props.techGroups[0] : null,
      selectedItems:
        props.techGroups.length > 0 ? [props.techGroups[0].groupId] : [],
      uioptions: [
        {
          id: 1,
          name: '',
          uioptions: props.techGroups
        }
      ]
    };
  }

  componentDidMount() {
    if (this.props.techGroups.length > 0) {
      this.renderSubItem(this.props.techGroups[0]);
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (
      !props.techGroups.find(
        (group) => group.groupId === state.selectedTechGroup.groupId
      )
    ) {
      return {
        ...state,
        selectedTechGroup: props?.techGroups?.[0],
        selectedItems: [props?.techGroups?.[0]?.groupId]
      };
    }
  }

  renderSubItem = (item) => {
    this.setState({ selectedTechGroup: item });
  };

  deleteTechGroup = (groupId) => {
    this.props.deleteTechnicianGroup({
      variables: { groupId }
    });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      let item = this.props.techGroups.find(
        (el) => el.groupId === selectedItem[selectedItem.length - 1]
      );
      this.renderSubItem(item);
    }
  };

  handleTechGroupChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { selectedTechGroup, selectedItems } = this.state;
    const {
      intl,
      sheetActive,
      toggleSheetActive,
      addOrUpdateTechGroup
    } = this.props;

    const { techGroups } = this.props;

    const processedAllItems = processData(techGroups, 'groupId');

    return (
      <div className="white-transparent-bg no-scroll fh">
        <div className="fx full-width ch-20">
          <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleTechGroupChange}
                />
              </div>
              {/* <SearchInput></SearchInput> */}
              <div className="scroll ch-50">
                <ResourceList
                  resourceName={{ singular: 'customer', plural: 'customers' }}
                  items={techGroups}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item, index) => {
                    const { groupId, name } = item;
                    return (
                      <ResourceItem
                        id={groupId}
                        accessibilityLabel={`View details for ${name}`}
                      >
                        <div className="fw list-item">
                          <div className="fx col">
                            <TextStyle variation="strong">{name} </TextStyle>
                          </div>
                        </div>
                        {item.uioptions && item.uioptions.length > 0 ? (
                          <div className="iconHolder">
                            <SVGIcon name="ArrowRight" />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </ResourceItem>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {selectedTechGroup && (
            <div className="fx col scroll w70 white-transparent-bg p2040 pr0">
              <div className="fx actr p20 pl10">
                <div className="fx2 ">
                  <Heading element="h2">{selectedTechGroup.name}</Heading>
                  <div className="wm-700 mt8">
                    <DisplayText element="p" size="large">
                      {selectedTechGroup.description || ''}
                    </DisplayText>
                  </div>
                </div>
                <div
                  data-qa="editBtn"
                  className="fx jend actr Technician-Group-Btn-Group"
                >
                  <ButtonGroup>
                    <div superid="editBtn">
                      <AccessControl
                        roleToCheck="technicianGroup.delete"
                        render={
                          <DeleteModal
                            id="deleteTechgroup"
                            description={getTranslatedText(
                              intl,
                              'admin.Techniciangroup.deletemsg'
                            )}
                            handleDeleteConfirmation={() =>
                              this.deleteTechGroup(selectedTechGroup.groupId)
                            }
                            title={getTranslatedText(
                              intl,
                              'admin.Techniciangroup.deletetitle'
                            )}
                          />
                        }
                      />
                    </div>
                    <div superid="deleteBtn">
                      <AccessControl
                        roleToCheck="technicianGroup.edit"
                        render={
                          <Button
                            url={
                              '#/onboard/techniciangroup/' +
                              selectedTechGroup.groupId +
                              '/edit'
                            }
                            secondary
                            icon={<SVGIcon name="Edit" />}
                          />
                        }
                      />
                    </div>
                  </ButtonGroup>
                </div>
              </div>
              <ScrollContent>
                <CardBox className="fx wrap pr10">
                  <div className="f11">
                    <div className="fx2 Technician-Group-Association f-20 mt-14 mb-14">
                      <div className="fx actr">
                        <TextStyle>
                          <FormattedMessage id="admin.Techniciangroup.Technicians" />
                        </TextStyle>
                      </div>
                    </div>
                    {selectedTechGroup.userList &&
                    selectedTechGroup.userList.length === 0 ? (
                      <div className="full-width flex center jcenter mt-30">
                        <NoDataCard
                          imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
                          text={
                            <FormattedMessage id="admin.technicianGroup.technicians.empty" />
                          }
                          type="secondary"
                        />
                      </div>
                    ) : (
                      <div className="py-10">
                        <ResourceList
                          items={selectedTechGroup.userList}
                          renderItem={(item) => {
                            const { userId, firstName, lastName, email } = item;
                            const media = (
                              <Avatar
                                size="medium"
                                name={firstName}
                                initials={`${firstName[0]}${lastName?.[0] ||
                                  ''}`}
                              />
                            );

                            return (
                              <ResourceItem
                                id={userId}
                                media={media}
                                accessibilityLabel={`View details for ${firstName} ${lastName}`}
                              >
                                <div className="fx col">
                                  <DisplayText element="h3" weight="SemiBold">
                                    {firstName} {lastName}
                                  </DisplayText>
                                  <TextStyle>{email}</TextStyle>
                                </div>
                              </ResourceItem>
                            );
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <AccessControl
                    productToCheck="MSP"
                    render={
                      <div className="f11">
                        <div className="fx2 Technician-Group-Association f-20 mt-14 mb-14">
                          <div className="fx actr">
                            <TextStyle>
                              <FormattedMessage id="admin.Techniciangroup.Clients" />
                            </TextStyle>
                          </div>
                        </div>
                        {selectedTechGroup?.accessAllClients && (
                          <div className="fx actr g10 pl20 pt10">
                            <SVGIcon name="ClientLogo" />
                            <DisplayText element="h3" weight="SemiBold">
                              <FormattedMessage id="client.listView.allClients" />
                            </DisplayText>
                          </div>
                        )}
                        {!selectedTechGroup?.accessAllClients &&
                          (selectedTechGroup.clientList &&
                          selectedTechGroup.clientList.length === 0 ? (
                            <div className="full-width flex center jcenter mt-30">
                              <NoDataCard
                                imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
                                text={
                                  <FormattedMessage
                                    id={getLokaliseKeyByProduct(
                                      this.state.currentProduct,
                                      'techGroupClientsEmpty'
                                    )}
                                  />
                                }
                                type="secondary"
                              />
                            </div>
                          ) : (
                            <div className="py-10">
                              <ResourceList
                                items={sortBy(
                                  selectedTechGroup.clientList,
                                  (obj) => obj.name.toLowerCase()
                                )}
                                renderItem={(item) => {
                                  const { accountId, name } = item;
                                  const media = <SVGIcon name="ClientLogo" />;

                                  return (
                                    <ResourceItem
                                      id={accountId}
                                      media={media}
                                      accessibilityLabel={`View details for ${name} `}
                                    >
                                      <DisplayText
                                        element="h3"
                                        weight="SemiBold"
                                      >
                                        {name}
                                      </DisplayText>
                                    </ResourceItem>
                                  );
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    }
                  />
                  <AccessControl
                    productToCheck="IT"
                    render={
                      <div className="f11">
                        <div className="fx2 Technician-Group-Association f-20 mt-14 mb-14">
                          <div className="fx actr">
                            <TextStyle>
                              <FormattedMessage id="common.sites" />
                            </TextStyle>
                          </div>
                        </div>
                        {selectedTechGroup?.accessAllSites && (
                          <div className="fx actr g10 pl20 pt10">
                            <SVGIcon name="Site" />
                            <DisplayText element="h3" weight="SemiBold">
                              <FormattedMessage
                                id={getLokaliseKeyByProduct(
                                  this.state.currentProduct,
                                  'techGroupAllClientSite'
                                )}
                              />
                            </DisplayText>
                          </div>
                        )}
                        {!selectedTechGroup?.accessAllSites &&
                          (selectedTechGroup.siteList &&
                          selectedTechGroup.siteList.length === 0 ? (
                            <div className="full-width flex center jcenter mt-30">
                              <NoDataCard
                                imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
                                text={
                                  <FormattedMessage
                                    id={getLokaliseKeyByProduct(
                                      this.state.currentProduct,
                                      'techGroupClientsEmpty'
                                    )}
                                  />
                                }
                                type="secondary"
                              />
                            </div>
                          ) : (
                            <div className="py-10">
                              <ResourceList
                                items={sortBy(
                                  selectedTechGroup.siteList,
                                  (obj) => obj.name.toLowerCase()
                                )}
                                renderItem={(item) => {
                                  const { accountId, name } = item;
                                  const media = <SVGIcon name="Site" />;

                                  return (
                                    <ResourceItem
                                      id={accountId}
                                      media={media}
                                      accessibilityLabel={`View details for ${name} `}
                                    >
                                      <DisplayText
                                        element="h3"
                                        weight="SemiBold"
                                      >
                                        {name}
                                      </DisplayText>
                                    </ResourceItem>
                                  );
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    }
                  />
                </CardBox>
              </ScrollContent>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(TechGroupCascade);
